import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AlertService} from '../../services/alert/alert.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {

    showError;

    constructor( private route: ActivatedRoute, private alertService: AlertService) {
        // checking router snapshot for query param if query param exists and the value is false i,e user does not exists in our database
        this.showError = this.route.snapshot.queryParams['access'];
        console.log(this.showError);
        // showing alert if  user does not exist
        if (this.showError !== undefined && this.showError !== null && this.showError === 'false') {
            this.alertService.warn('User does not exist, please login through signon page');
        }
    }

    ngOnInit() {
}
}
